import React, { ReactElement } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import 'jquery';
import 'bootstrap';

// AdminLTE components need to be imported individually.
// There's a bug in SidebarSearch.js that crashes the app.
import 'admin-lte/build/js/CardRefresh';
import 'admin-lte/build/js/CardWidget';
import 'admin-lte/build/js/ControlSidebar';
import 'admin-lte/build/js/DirectChat';
import 'admin-lte/build/js/Dropdown';
import 'admin-lte/build/js/ExpandableTable';
import 'admin-lte/build/js/Fullscreen';
import 'admin-lte/build/js/Layout';
import 'admin-lte/build/js/PushMenu';
import 'admin-lte/build/js/Toasts';
import 'admin-lte/build/js/TodoList';
import 'admin-lte/build/js/Treeview';

import './icons';
import './App.scss';

import Module from './components/Module';
import modules from './modules';
import Home from './features/Home';

const App = (): ReactElement => {
  return (
    <Router>
      {modules.map((config) => {
        return (
          <Route key={config.name} path={`/${config.name}`}>
            <Module config={config} />
          </Route>
        );
      })}
      <Route path="/" exact>
        <Home />
      </Route>
    </Router>
  );
};

export default App;
